import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";

const headingStyles = {
  h1: { fontSize: "20px", lineHeight: 1.3, fontWeight: 600 },
  h2: { fontSize: "18px", lineHeight: 1.3, fontWeight: 600 },
  h3: { fontSize: "16px", lineHeight: 1.4, fontWeight: 500 },
  h4: { fontSize: "15px", lineHeight: 1.4, fontWeight: 500 },
  h5: { fontSize: "14px", lineHeight: 1.4, fontWeight: 500 },
  h6: { fontSize: "13px", lineHeight: 1.4, fontWeight: 500 },
};

const MarkdownRenderer = ({ content, sendQuery }) => {
  const cleanContent = content
    ?.replace(/^```markdown\s*/i, "")
    ?.replace(/```$/i, "")
    ?.trim()
    // wrap button with div to force HTML block
    ?.replace(/(<button[\s\S]*?<\/button>)/gi, "<div>$1</div>");

  function extractLeadDetails(text) {
    const result = {};
    const regex = /-\s\*\*(.+?)\*\*:\s(.+)/g;
    let match;

    while ((match = regex.exec(text)) !== null) {
      const key = match[1].toLowerCase().replace(/\s+/g, "_");
      const value = match[2].trim();
      result[key] = value;
    }

    return result;
  }

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        h1: ({ node, ...props }) => <h1 style={headingStyles.h1} {...props} />,
        h2: ({ node, ...props }) => <h2 style={headingStyles.h2} {...props} />,
        h3: ({ node, ...props }) => <h3 style={headingStyles.h3} {...props} />,
        h4: ({ node, ...props }) => <h4 style={headingStyles.h4} {...props} />,
        h5: ({ node, ...props }) => <h5 style={headingStyles.h5} {...props} />,
        h6: ({ node, ...props }) => <h6 style={headingStyles.h6} {...props} />,

        a: ({ node, ...props }) => <a className="text-theme" {...props} />,

        button: ({ node, ...props }) => {
          const action = props["data-action"];
          const url = props["data-url"];
          const handleClick = () => {
            if (action === "navigate" && url) {
              window.location.href = url;
            }
            if (props.children?.toLowerCase()?.includes("send email")) {
              const leadJson = extractLeadDetails(content);

              sendQuery && sendQuery(`send email to ${leadJson?.email}`);
            }
          };

          return (
            <Button
              type="primary"
              block
              className={`tw-rounded-[10px] tw-border-[#CDD2DF] hover:!tw-border-[#D0C9FF] tw-bg-white hover:!tw-bg-[#F2F0FF] tw-text-xs tw-font-medium tw-text-text-primary hover:!tw-text-theme tw-flex tw-justify-between tw-items-center mt10 ${props.className || ""}`}
              onClick={handleClick}
            >
              {props.children}
              <ArrowRightOutlined />
            </Button>
          );
        },

        table: ({ node, ...props }) => (
          <div style={{ overflowX: "auto", margin: "12px 0" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #f0f0f0",
              }}
              {...props}
            />
          </div>
        ),
        thead: ({ node, ...props }) => (
          <thead style={{ backgroundColor: "#fafafa" }} {...props} />
        ),
        tr: ({ node, ...props }) => (
          <tr style={{ borderBottom: "1px solid #f0f0f0" }} {...props} />
        ),
        th: ({ node, ...props }) => (
          <th
            style={{
              border: "1px solid #f0f0f0",
              padding: "8px 10px",
              fontWeight: 600,
              textAlign: "left",
              fontSize: "13px",
            }}
            {...props}
          />
        ),
        td: ({ node, ...props }) => (
          <td
            style={{
              border: "1px solid #f0f0f0",
              padding: "8px 10px",
              fontSize: "13px",
            }}
            {...props}
          />
        ),
      }}
    >
      {cleanContent}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
